import { PageLayout } from '@/components/feature/PageLayout';

const seo = {
  title: 'Politique de confidentialité | Volet Charleroi',
  description: 'Politique de confidentialité du site Volet Charleroi. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles conformément au RGPD.',
  canonicalUrl: '/politique-confidentialite/',
  noindex: true,
};

export default function PolitiqueConfidentialitePage() {
  return (
    <PageLayout seo={seo} showDevisForm={false}>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-700 mb-8">
            Politique de confidentialité
          </h1>

          <div className="space-y-8 text-sm md:text-base text-foreground-600 leading-relaxed">
            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">1. Introduction</h2>
              <p>
                La présente politique de confidentialité a pour but d'informer les utilisateurs du site <strong>volet-charleroi.be</strong> sur la manière dont leurs données personnelles sont collectées, traitées et protégées, conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la législation belge en vigueur.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">2. Responsable du traitement</h2>
              <p className="mb-2">Le responsable du traitement des données est :</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Entreprise : Volet Charleroi</li>
                <li>Adresse : 6000 Charleroi, Belgique</li>
                <li>Email : <a href="mailto:info@volet-charleroi.be" className="text-accent-500 hover:text-accent-600 underline">info@volet-charleroi.be</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">3. Données collectées</h2>
              <p className="mb-2">Lorsque vous utilisez notre formulaire de contact ou de demande de devis, nous collectons les données suivantes :</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Nom et prénom</li>
                <li>Numéro de téléphone</li>
                <li>Adresse email</li>
                <li>Commune de résidence</li>
                <li>Type de panne ou motif de la demande</li>
                <li>Message décrivant votre problème</li>
              </ul>
              <p className="mt-2">
                Ces données sont collectées via notre formulaire hébergé par Formspree et sont nécessaires au traitement de votre demande.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">4. Finalité du traitement</h2>
              <p>Les données collectées sont utilisées exclusivement pour :</p>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>Répondre à votre demande de devis ou de contact</li>
                <li>Vous recontacter dans le cadre de la prestation demandée</li>
                <li>Assurer le suivi de votre dossier</li>
              </ul>
              <p className="mt-2">
                Aucune donnée n'est utilisée à des fins de prospection commerciale sans votre consentement explicite.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">5. Base légale du traitement</h2>
              <p>
                Le traitement de vos données repose sur votre consentement (article 6.1.a du RGPD), matérialisé par la case à cocher présente sur notre formulaire, et sur l'exécution de mesures précontractuelles (article 6.1.b du RGPD) liées à votre demande de devis.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">6. Durée de conservation</h2>
              <p>
                Vos données personnelles sont conservées pendant la durée nécessaire au traitement de votre demande, et au maximum pendant 3 ans à compter du dernier contact, sauf obligation légale de conservation plus longue.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">7. Cookies</h2>
              <p>
                Notre site utilise des cookies techniques essentiels à son bon fonctionnement. Un bandeau de consentement vous informe de l'utilisation de ces cookies lors de votre première visite. Vous pouvez à tout moment gérer vos préférences en matière de cookies via les paramètres de votre navigateur.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">8. Vos droits</h2>
              <p className="mb-2">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Droit d'accès</strong> : obtenir la confirmation que vos données sont traitées et y avoir accès</li>
                <li><strong>Droit de rectification</strong> : faire corriger des données inexactes</li>
                <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
                <li><strong>Droit à la limitation du traitement</strong> : restreindre le traitement dans certains cas</li>
                <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
                <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
              </ul>
              <p className="mt-2">
                Pour exercer ces droits, contactez-nous à <a href="mailto:info@volet-charleroi.be" className="text-accent-500 hover:text-accent-600 underline">info@volet-charleroi.be</a>. Vous disposez également du droit d'introduire une réclamation auprès de l'Autorité de protection des données (APD) en Belgique.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">9. Sécurité</h2>
              <p>
                Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données contre la destruction accidentelle ou illicite, la perte, l'altération, la divulgation non autorisée ou l'accès non autorisé.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">10. Modification de la politique</h2>
              <p>
                Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. La version la plus récente sera toujours disponible sur cette page.
              </p>
              <p className="mt-2 text-foreground-400">
                Dernière mise à jour : juillet 2026
              </p>
            </section>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}